/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import Swal from 'sweetalert2';

import { MdLock } from 'react-icons/md';

import { Modal } from 'antd';

import api from '~/services/api';

import history from '~/services/history';

// actions

import { signInSuccess } from '~/store/modules/auth/actions';

import {
  ContainerFull,
  Container,
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

import Breadcumbs from '~/components/Breadcumbs';

import ModalPendenciaDeEnvio from '~/components/ModalPendenciaDeEnvio';
import ModalPerfilPendente from '~/components/ModalPerfilPendente';

const Dashboard = () => {
  const dispatch = useDispatch();

  const { roles, systemConfig, token } = useSelector(state => state.auth);

  const authState = useSelector(state => state.auth);

  const cpfUser = sessionStorage.getItem('cpf');

  const {
    pendenciaDeEnvio,
    urlSuperset,
    perfilInstituicaoPendente,
    dataUltimoPerfilInstituicao,
  } = systemConfig;

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  const ROLE_USER = roles.includes('ROLE_USER');

  const urlIframe = `${urlSuperset}/login/?username=${cpfUser}&redirect=/superset/dashboard/tela_inicial_ans/`;
  console.log(urlIframe)

  const [visible, setVisible] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [modalPendenciaDeEnvio, setModalPendenciaDeEnvio] = useState(false);

  const [pendenciaDeEnvioStorage, setPendenciaDeEnvioStorage] = useState('0');

  const getSystemconfig = async () => {
    try {
      const response = await api.get('configuracoes-sistema', {
        headers: {
          Authorization: String(token),
        },
      });

      const newSystemConfig = {
        ...authState.systemConfig,
        pendenciaDeEnvio: response.data.pendenciaDeEnvio,
      };

      if (response?.data?.pendenciaDeEnvio?.length < 1) {
        setModalPendenciaDeEnvio(false);
      }

      dispatch(
        signInSuccess({
          ...authState,
          systemConfig: newSystemConfig,
        })
      );

      const { pendenciaReabertura } = response.data;

      if (pendenciaReabertura && ROLE_ADMIN) {
        setVisible(true);
      }
    } catch (error) {
      //
    }
  };

  const handleOk = () => {
    setConfirmLoading(true);

    history.push('/administrador/instituicoes-participantes');
  };

  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (
      ROLE_USER &&
      pendenciaDeEnvio?.length > 0 &&
      sessionStorage.getItem('PendenciaDeEnvio') !== '1'
    ) {
      setTimeout(() => {
        setModalPendenciaDeEnvio(true);
      }, 2000);
    }
  }, [pendenciaDeEnvioStorage]);

  useEffect(() => {
    getSystemconfig();
  }, []);

  return (
    <>
      <ModalPendenciaDeEnvio
        setModalPendenciaDeEnvio={setModalPendenciaDeEnvio}
        modalPendenciaDeEnvio={modalPendenciaDeEnvio}
        mesesPendentes={pendenciaDeEnvio}
      />
      <ModalPerfilPendente
        perfilInstituicaoPendente={perfilInstituicaoPendente}
        dataUltimoPerfilInstituicao={dataUltimoPerfilInstituicao}
      />
      <Modal
        visible={visible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        cancelText="Conferir depois"
        centered
        footer={null}
        width="480px"
      >
        <ModalContainer>
          <ModalHeader>
            <div className="iconModal">
              <span>
                <MdLock size={30} />
              </span>
            </div>
            <h2>
              Existem pedidos <br />
              de
              <span>
                {' '}
                reabertura de <br />
                competência
              </span>{' '}
              pendentes
            </h2>
          </ModalHeader>
          <div className="ModalBody">
            <p>
              Se preferir “Conferir depois”, você poderá encontrar as pendências
              na listagem de “Instituições participantes”. O botão “Indicadores”
              estará vermelho para instituições com pedidos pendentes.
            </p>
          </div>
        </ModalContainer>

        <ModalFooter>
          <ButtonModal type="button" onClick={handleOk}>
            {confirmLoading ? ' Enviando...' : 'Conferir agora'}
          </ButtonModal>
          <ButtonModal type="button" cancel onClick={handleCancel}>
            Conferir depois
          </ButtonModal>
        </ModalFooter>
      </Modal>

      <ContainerFull>
        <div className="ContainerBreadcumbs">
          <Breadcumbs
            path="indicadores-gerais"
            pathTitle="Painéis de Indicadores"
          />
        </div>
        <Container>
          <iframe
            id="frame"
            name="frame"
            title="SuperSet"
            src={urlIframe}
            frameBorder="0"
          />
        </Container>
      </ContainerFull>
    </>
  );
};

export default Dashboard;
